import React from 'react';
import styled from '@emotion/styled';
import { Text } from '@chakra-ui/react';
import { CancelCircleIcon } from 'static/icons';
import { PrimaryButton } from 'components';

const ContainerStyled = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
`;

const CancelCircleIconStyled = styled(CancelCircleIcon)`
  color: ${({ theme }) => theme.colors.highlight};
  margin-top: auto;
`;

export const VisitInfoErrorPage: React.FC<{
  homeLink: string;
  status: number;
}> = ({ homeLink, status }) => {
  return (
    <ContainerStyled>
      <CancelCircleIconStyled width={106} height={106} />
      {status === 404 ? (
        <Text color="black" textStyle="h2" mt="6">
          Запись не найдена
        </Text>
      ) : (
        <>
          <Text color="black" textStyle="h2" mt="6">
            Ошибка
          </Text>
          <Text textStyle="body1" mx={2} textAlign="center">
            Проверьте правильность ввода и попробуйте ещё раз
          </Text>
        </>
      )}
      <PrimaryButton
        as="a"
        href={homeLink}
        w="199px"
        mt="auto"
        mb={{ base: '74px', md: '143px' }}
      >
        Записаться еще
      </PrimaryButton>
    </ContainerStyled>
  );
};
